import { HeaderSection } from '@lmc/ui-kit'
import dayjs from 'dayjs'
import { chain, get, sortBy } from 'lodash'
import { Component } from 'react'
import { LogFilter } from '../../../components/generic'
import ChartPdfExport from '../../../components/pdf/ChartPdfExport'
import { history } from '../../../store'

// Simple HOC that wraps each chart in toolbar, filter and export features
export default function withToolbar(WrappedComponent, config = {}) {
  return class extends Component {
    constructor(props) {
      super(props)
      const { to, from } = this.getDefaultDates(config.timeWindow || 1)
      const logs = this.getLogs(props.data, from)
      const state = {
        showMock: false
      }
      // if the filter doesn't return a large enough dataset (len 3), show the whole window
      state.to = to
      state.from = from
      state.logs = logs

      this.state = state
    }

    // to avoid rendering data that's outside the default date range
    // maybe put into a utils method?
    getLogs = (logs, from) =>
      chain(logs)
        .sortBy('timeLogged')
        .filter(
          (log) =>
            from.startOf('day').diff(dayjs(log.timeLogged).startOf('day')) <= 0
        )
        .value()

    getDefaultDates = (timeWindow) => ({
      to: dayjs().endOf('day'),
      from: dayjs().subtract(timeWindow, 'days').startOf('day')
    })

    setDates = ({ startDate, endDate }) => {
      this.setState({
        to: endDate ? dayjs(endDate).endOf('day') : null,
        from: startDate ? dayjs(startDate).startOf('day') : null
      })
    }

    onFilterChange = (logs) => {
      this.setState({
        logs: sortBy(logs, (d) => dayjs(d.timeLogged))
      }) // ensure that they're sorted by date!
    }

    renderToolbar = () => {
      const { data, resident } = this.props
      const { logs } = this.state
      const hasData = data && logs && logs.length

      let url = `/residents`
      if (resident) url += `/${resident.id}/charts`
      return (
        <HeaderSection
          title={config?.title || config?.pdfExport?.title}
          backLink
          onClick={() => history.push(url)}
          rightChildren={
            hasData ? (
              <ChartPdfExport
                logs={logs}
                resident={this.props.resident}
                {...config.pdfExport}
              />
            ) : null
          }
        />
      )
    }

    render() {
      const { params, data, filterPadding } = this.props
      const { logs, to, from } = this.state

      const filterStyle =
        get(config, 'dateFilter.left') === true
          ? { paddingBottom: 25 }
          : {
              // textAlign: 'center',
              paddingBottom: filterPadding || 25,
              paddingRight: 13
            }

      // const hideLogFilter = !logs || !logs.length
      const isDashboard = params && params.chart_type !== 'dashboard'
      return (
        <div>
          {isDashboard ? this.renderToolbar() : null}
          {!config.hideLogFilter && (
            <div style={filterStyle}>
              <LogFilter
                to={to}
                from={from}
                blockFuture
                data={data}
                onChange={this.onFilterChange}
                onNewDates={this.setDates}
                maximumNights={config.maximumNights}
              />
            </div>
          )}
          <div style={styles.chartContainer}>
            <WrappedComponent
              to={to}
              from={from}
              logs={logs}
              {...this.props}
              {...config.childProps}
            />
          </div>
        </div>
      )
    }
  }
}

export const styles = {
  chartContainer: {}
}
